<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  mounted() {
    var to = this.$route
    this.createPageTitle(to)
  },
  watch: {
    $route(to) {
      this.createPageTitle(to)
    },
  },
  methods: {
    createPageTitle(routeObj) {
      if (routeObj.meta.title) document.title = routeObj.meta.title
    },
  },
}
</script>
<style lang="scss">
#app {
  font-family: 'メイリオ', 'Meiryo', 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #515a6e;
}
</style>
